<div
  class="notification-item px-2 pt-2 pb-0"
  [caLocalizationScope]="localizationScope"
  data-automation-id="activity-notification-item"
>
  <div class="d-flex align-items-start">
    <!-- Unread dot: visible only when unread -->
    <div class="notification-dot-container d-flex justify-content-center flex-shrink-0 me-1">
      @if (!notification().read) {
      <span
        class="notification-unread-dot d-block bg-primary rounded-circle"
        data-automation-id="unread-indicator"
      ></span>
      }
    </div>

    <!-- Title + date -->
    <div class="flex-grow-1 overflow-hidden">
      <a
        class="link link-main mb-1 text-truncate"
        [title]="body()?.activitySubject || notification().title"
        (click)="onOpen()"
        data-automation-id="activity-notification-open-btn"
      >
        {{ body()?.activitySubject || notification().title }}
      </a>
      <div class="body-50 text-muted" data-automation-id="activity-date">
        {{ notification().createdAt | date : 'MM/dd/yyyy' }}
      </div>
    </div>

    <!-- Delete -->
    <a
      class="btn btn-icon align-self-center"
      type="button"
      (click)="onDelete()"
      data-automation-id="delete-notification-btn"
      [title]="'delete' | caLocalize"
    >
      <i class="f-i f-i-close f-i-sm"></i>
    </a>
  </div>

  <!-- Divider -->
  <hr class="opacity-100 m-0 mt-2" />
</div>
